import React, { useEffect } from 'react';
import Header from '../header';
import Footer from '../footer';
import { useSelector } from 'react-redux';
import { langSelector } from '../../store/langSlice';
import { getLang } from '../../environnement';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../components/customButton';

export default function AproposCentre({
  activeItem
}) {
  const lang = useSelector(langSelector);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
      <div className='flex flex-col justify-between'>
      <Header activeItem={activeItem} />
      <div className='flex justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] mx-10 mt-10' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>
          <div className='mb-10'>
            <p className='font-inter text-primary font-medium text-xl sm:text-3xl mb-3'>{getLang(lang).aproposCentre.aproposCentre}</p>
            <p className='font-inter font-medium text-xl sm:text-3xl'>{getLang(lang).aproposCentre.aproposCentreContent}</p>
          </div>
          <div className='mb-10'>
            <p className='font-inter text-primary font-medium text-xl sm:text-3xl mb-3'>{getLang(lang).aproposCentre.notreMission}</p>
            <p className='font-inter font-medium text-xl sm:text-3xl'>{getLang(lang).aproposCentre.notreMissionContent}</p>
          </div>
          <div className='mb-10'>
            <p className='font-inter text-primary font-medium text-xl sm:text-3xl mb-3'>{getLang(lang).aproposCentre.nosInstallations}</p>
            <ul className='list-disc ml-8'>
              <li className='font-inter font-medium text-xl sm:text-3xl mb-5'>{getLang(lang).aproposCentre.nosInstallationsItem1}</li>
              <li className='font-inter font-medium text-xl sm:text-3xl mb-5'>{getLang(lang).aproposCentre.nosInstallationsItem2}</li>
              <li className='font-inter font-medium text-xl sm:text-3xl mb-5'>{getLang(lang).aproposCentre.nosInstallationsItem3}</li>
              <li className='font-inter font-medium text-xl sm:text-3xl'>{getLang(lang).aproposCentre.nosInstallationsItem4}</li>
            </ul>
          </div>
          <div style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>
            <CustomButton
              value={getLang(lang).aproposCentre.revenirPageAccueil}
              handelClick={() => navigate('/')}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
